import { MY_COLLECTIONS_TYPES, MY_COLLECTIONS_IDS } from 'shared-constants/src/mycasa26/collection_configurations';

import { addLSFavorite, removeLSFavorite } from 'shared-utils/src/myCasaEasyLoginAction/favorites';
import fetchNewMyCasaProxy from 'shared-utils/src/fetchNewMyCasaProxy';
import { getCollectionNode, setCollectionNode } from 'shared-utils/src/myCasaCollections';

import { fromArrayToObject } from '@helpers/dataModels/poi';
import { defaultBookmarkData } from '@helpers/MyCasaHelpers';

export default async (state, type, payload) => {
  let newState = state;

  const user = payload?.user || state.user || { isAuthenticated: false };

  switch (type) {
    case 'storePrevFilters': {
      newState = {
        prevFilterState: {
          filters: state.filters,
          agencyFreetext: state.agencyFreetext || {},
          availableResults: state.availableResults,
          locations: state.locations,
          parentLocation: state.parentLocation,
        },
      };
      break;
    }
    case 'restorePrevFilters': {
      newState = {
        ...state.prevFilterState,
      };
      break;
    }
    case 'updateSelectedPoi': {
      const { filters } = state;
      newState = {
        filters: {
          ...filters,
          poi: payload && payload.length > 0 ? fromArrayToObject(payload) : null,
        },
      };
      break;
    }
    case 'deleteBookmark': {
      newState = {
        searchIsSaved: false,
        bookmarkData: defaultBookmarkData,
      };
      break;
    }
    case 'addFavoriteArticle': {
      const {
        id: listingId,
        refreshUser,
        portal26Domain,
        onActionSuccess,
      } = payload;
      
      const { isAuthenticated } = user;

      if (isAuthenticated) {
        try {
          const res = await fetchNewMyCasaProxy({
            portal26Domain,
            method: 'POST',
            body: JSON.stringify({
              type: MY_COLLECTIONS_TYPES.ADS,
              id: MY_COLLECTIONS_IDS.SAVED,
              data: [{ id: listingId }],
            }),
          });

          if (res.status === 200) {
            const node = getCollectionNode(MY_COLLECTIONS_TYPES.ADS, MY_COLLECTIONS_IDS.SAVED);
            const currentFavorites = node?.data || [];
            if (!currentFavorites.includes(listingId)) {
              const newFavorites = [...currentFavorites, listingId];
              setCollectionNode(MY_COLLECTIONS_TYPES.ADS, MY_COLLECTIONS_IDS.SAVED, { data: newFavorites, count: newFavorites.length });
            }

            onActionSuccess && onActionSuccess();
            newState = {
              favorites: [...state.favorites, listingId],
            };
          } else {
            console.log('savePDP failed with status', res.status);
          }
        } catch (error) {
          console.log('savePDP error', error);
        }
      } else {
        addLSFavorite({ listingId });
        refreshUser && refreshUser();
        newState = {
          favorites: [...state.favorites, listingId],
        };        
      }
      break;
    }
    case 'removeFavoriteArticle': {
      const { portal26Domain, id: listingId } = payload;

      const { isAuthenticated } = user;

      if (isAuthenticated) {
        try {
          const res = await fetchNewMyCasaProxy({
            portal26Domain,
            method: 'DELETE',
            type: MY_COLLECTIONS_TYPES.ADS,
            id: MY_COLLECTIONS_IDS.SAVED,
            body: JSON.stringify({
              type: MY_COLLECTIONS_TYPES.ADS,
              id: MY_COLLECTIONS_IDS.SAVED,
              data: [{ id: listingId }],
            }),
          });

          if (res.status === 200) {
            const node = getCollectionNode(MY_COLLECTIONS_TYPES.ADS, MY_COLLECTIONS_IDS.SAVED);
            const newFavoritesList = (node?.data || []).filter((id) => id !== listingId);
            newState = { favorites: newFavoritesList };
            setCollectionNode(MY_COLLECTIONS_TYPES.ADS, MY_COLLECTIONS_IDS.SAVED, { data: newFavoritesList, count: newFavoritesList.length });
          } else {
            console.log('deletePDP failed with status', res.status);
          }
        } catch (error) {
          console.log('deletePDP error', error);
        }
      } else {
        removeLSFavorite({ listingId });
        newState = { favorites: state.favorites.filter((item) => item !== listingId) };
      }
      break;
    }
    case 'fpIconClicked': {
      newState = payload;
      break;
    }
    case 'ptypesSelectFromModal': {
      newState = {
        ptypesSelectFromModal: payload,
      };
      break;
    }
    case 'noMoreFpFeedback': {
      const { filters } = state;
      newState = {
        filters: {
          ...filters,
          ...payload,
        },
      };
      break;
    }
    case 'disableProposeBkmAfterLead':
      newState = {
        proposeBkmAfterLead: {
          propose: false,
          reason: 'No-HasSavedSearches',
        },
      };
      break;
  }

  return newState;
};
